import type { LabelCatalogMatch } from './LabelEditor'

/** Count label occurrences across many owners' label lists. */
export function catalogFromLabelLists(
  labelLists: readonly (readonly string[] | undefined)[]
): LabelCatalogMatch[] {
  const counts = new Map<string, number>()
  for (const labels of labelLists) {
    if (!labels) continue
    for (const raw of labels) {
      const name = raw.trim()
      if (!name) continue
      counts.set(name, (counts.get(name) ?? 0) + 1)
    }
  }
  return [...counts.entries()]
    .map(([label, count]) => ({ label, count }))
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
}

/** Prefer the higher count when the same label appears in both sources. */
export function mergeLabelCatalogs(
  ...sources: readonly (readonly LabelCatalogMatch[])[]
): LabelCatalogMatch[] {
  const counts = new Map<string, number>()
  for (const source of sources) {
    for (const entry of source) {
      const prev = counts.get(entry.label) ?? 0
      if (entry.count > prev) counts.set(entry.label, entry.count)
      else if (!counts.has(entry.label)) counts.set(entry.label, entry.count)
    }
  }
  return [...counts.entries()]
    .map(([label, count]) => ({ label, count }))
    .sort((a, b) => b.count - a.count || a.label.localeCompare(b.label))
}
